<template>
	<p-card class="payroll-proposal-form">
		<div>
			<div v-for="field in formFields" class="payroll-proposal-field tw-flex" :key="field.id">
				<div class="tw-w-1/2 tw-flex tw-justify-between">
					<h3 class="tw-m-0 uppercase text-info">{{ field.name }}</h3>
					<v-tooltip top>
					<span slot="activator">	<circle-info-icon class="cursor-pointer" @click="$emit('infoClick', field.name)" /></span>
				Digita el valor en unidades monetarias mensual o anual del costo presupuestado de los puestos valorados.
				</v-tooltip>
				</div>
				<div class="tw-w-1/2 tw-flex tw-justify-end">
					<div class="tw-w-32">
						<v-text-field
							solo
							class="input-text payroll-proposal-input"
							type="number"
							placeholder="0.00"
							v-model="formValues[field.uuid]"
						></v-text-field>
					</div>
				</div>
			</div>
		</div>
	</p-card>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import CircleInfoIcon from '@/modules/shared/components/icons/circle-info-icon';

export default {
	name: 'payroll-proposal-form',
	components: { CircleInfoIcon, PCard },
	props: ['formFields', 'value'],
	data() {
		return {
			formValues: {},
		};
	},
	watch: {
		formValues: {
			handler(newValue) {
				this.formValues = newValue;
				this.$emit('onChangeValue', newValue);
			},
		},
		value: {
			handler(newValue) {
				this.formValues = newValue;
			},
		},
	},
};
</script>

<style lang="scss">
.payroll-proposal-form {
	.payroll-proposal-input {
		input {
			font-size: 25px !important;
			padding: 0;
			text-align: center;
		}
	}
}

</style>

<style lang="scss" scoped>
.payroll-proposal-form {
	min-height: 500px;
	.payroll-proposal-field {
		background-color: #f5f5f5;
		padding: 30px 50px;
		margin: 0px -20px 10px;
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/payroll-proposal/payroll-proposal-form.vue